// extracted by mini-css-extract-plugin
export var featureTable = "pricing-module--featureTable--2cbd3";